.header {
  margin: 0;
  padding: 8px;
  border-radius: 16px;
  background: linear-gradient(
    45deg,
    var(--tuna-palette-background-default) 0%,
    var(--tuna-palette-background-default) 20%,
    var(--tuna-palette-primary-main) 50%,
    var(--tuna-palette-background-default) 80%
  );
}

.headerSpaces {
  margin-bottom: 32px;
  margin-top: 0;
}

.spacesWrapper {
  position: relative;
}

.addButton {
  position: absolute;
  right: 0;
  top: 0;
  margin-top: 8px;
}

.spacer {
  flex: 1;
}

.fabContainer {
  position: fixed;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  z-index: 1050;
}

@media (max-width: 899.95px) {
  .fabContainer {
    bottom: 72px;
  }
}
